module.exports = __webpack_public_path__ + "67d8166730e100f71d6ac81c3de51c0c.svg";